export const FilterOption = {
    AND: 'All',
    OR: 'Any'
}


// WEBPACK FOOTER //
// ./src/app/shared/constants/filter.constants.ts